module.exports = __webpack_public_path__ + "img/many-profiles.a48fe774.svg";